var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59375 18.3438C2.06094 18.3438 1.60498 18.1542 1.22588 17.7751C0.846771 17.396 0.656896 16.9397 0.65625 16.4062V2.84375C0.65625 2.31094 0.846125 1.85498 1.22588 1.47588C1.60563 1.09677 2.06158 0.906896 2.59375 0.90625H16.1562C16.6891 0.90625 17.1453 1.09613 17.5251 1.47588C17.9048 1.85563 18.0944 2.31158 18.0938 2.84375V16.4062C18.0938 16.9391 17.9042 17.3953 17.5251 17.7751C17.146 18.1548 16.6897 18.3444 16.1562 18.3438H2.59375ZM3.5625 14.4688H15.1875L11.5547 9.625L8.64844 13.5L6.46875 10.5938L3.5625 14.4688Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59375 18.3438C2.06094 18.3438 1.60498 18.1542 1.22588 17.7751C0.846771 17.396 0.656896 16.9397 0.65625 16.4062V2.84375C0.65625 2.31094 0.846125 1.85498 1.22588 1.47588C1.60563 1.09677 2.06158 0.906896 2.59375 0.90625H16.1562C16.6891 0.90625 17.1453 1.09613 17.5251 1.47588C17.9048 1.85563 18.0944 2.31158 18.0938 2.84375V16.4062C18.0938 16.9391 17.9042 17.3953 17.5251 17.7751C17.146 18.1548 16.6897 18.3444 16.1562 18.3438H2.59375ZM3.5625 14.4688H15.1875L11.5547 9.625L8.64844 13.5L6.46875 10.5938L3.5625 14.4688Z",
    fill: "url(#paint0_linear_6762_53469)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6762_53469",
    x1: 9.375,
    y1: 0.90625,
    x2: 9.375,
    y2: 18.3438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00173D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageicon);
export default __webpack_public_path__ + "static/media/imageicon.d2e102246c9f8c42424bb173b6771c6f.svg";
export { ForwardRef as ReactComponent };